import {
  AstralWalletOrderStatus,
  AstralWalletPaymentStatus,
  AstralWalletPaymentType,
} from 'plugins/CheckoutPlugin/types/CheckoutTypes';
import { createContext, useContext } from 'react';

type AstralWalletStatusContextType = {
  paymentStatus: AstralWalletPaymentStatus;
  orderStatus: AstralWalletOrderStatus;
  paymentType: AstralWalletPaymentType;
  paymentId: string;
  isLoading: boolean;
  retryAstralWalletStatusInterval: () => void;
};

export const AstralWalletStatusContext = createContext<
  AstralWalletStatusContextType | undefined
>(undefined);

export const useAstralWalletStatus = () => {
  const context = useContext(AstralWalletStatusContext);
  if (!context) {
    console.error('Must be used within <AstralWalletStatus>');
  }
  return context;
};
